import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpBackendService } from 'src/app/core/backend-services/http/http.backend-service';
import { SocketIoService } from 'src/app/core/services/socket-io/socket-io.service';

@Injectable({
  providedIn: 'root',
})
export class LobbyBackendService {
  private readonly BASE_ADDRESS = '/game/table';

  /**
   * @description constructor of LobbyBackendService
   * @param {HttpBackendService} http - http backend service
   * @param {SocketIoService} socket - socket io service
   */
  constructor(
    private http: HttpBackendService,
    private socket: SocketIoService
  ) {}

  /**
   * @description gets tables list
   * @returns {Promise<any[]>}
   */
  public getTables(): Promise<any[]> {
    return firstValueFrom(this.http.get<any[]>(`${this.BASE_ADDRESS}`));
  }

  /**
   * @description toggle want to leave after bummerl status
   * @param {boolean} wantToLeave - whether user wants to leave after bummerl
   * @returns {Promise<void>}
   */
  public toggleWantToLeave(wantToLeave: boolean): Promise<void> {
    return this.socket.post(`${this.BASE_ADDRESS}/toggle-want-to-leave`, {
      wantToLeave,
    });
  }
}
